import React from 'react';
import { EditDateInline } from './shared/EditDateInline';
import { TransactionValidationSchemaGenerator } from '../../EditTransactionPrice/TransactionValidationSchema';
import { SmallBodyText } from '../../../../../ui-toolkit';
import { SummaryItemWithTooltip } from '../../../../shared/Summary/SummaryItem/SummaryItemWithTooltip';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export const EstimatedClosingDate: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  const isPurchase = order.transaction.transaction_category === eTransactionCategory.Purchase;

  if (isPurchase) {
    return null;
  }
  return (
    <SummaryItemWithTooltip
      label={`Estimated Closing Date`}
      tab={`summary`}
      tooltip={EditDateInline}
      tooltipProps={{
        validationSchema: TransactionValidationSchemaGenerator(
          order.transaction.transaction_category,
          'estimated_closing_date'
        ),
        value: order.transaction.estimated_closing_date,
        onUpdateOrder: async (value: string | null) =>
          await onPatchOrderInformation({ estimatedClosingDate: value ?? null }),
        highlightDate: 'today',
      }}
    >
      {getDateString('LLLL d, yyyy', order.transaction.estimated_closing_date) || (
        <SmallBodyText intent={'faded'}>Not Scheduled</SmallBodyText>
      )}
    </SummaryItemWithTooltip>
  );
};
